import React, {useState} from 'react';
import './Contact.scss';

const SCRIPT_URL = process.env.REACT_APP_GOOGLE_SCRIPT_URL;
if (!SCRIPT_URL) {
  console.error("Google Script URL is missing");
}

const Contact = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await fetch(SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify(form)
      });

      alert('Message sent successfully!');
      setForm({ name: '', email: '', company: '', message: '' });
    } catch (error) {
      console.error(error);
      alert('Failed to send message. Please try again.');
    }
  };

  return (
    <section id="contact" className="contact section-padding">
      <div className="contact-inner max-width">

        <div>
          <h2>Ready to <span style={{color:'var(--orange)'}}>Skyrocket Your Growth?</span></h2>
          <p style={{color:'#aaa'}}>Let's craft a strategy that transforms your digital presence.</p>

          {/* CONTACT INFO */}
          <div className="contact-info">
            <a href="tel:+918341062346" className="contact-info__pill">
              <span className="contact-info__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.81a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </span>
              <span className="contact-info__label">+91 8341062346</span>
            </a>
            <a href="mailto:info@zorand.in" className="contact-info__pill">
              <span className="contact-info__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="16" x="2" y="4" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
              </span>
              <span className="contact-info__label">info@zorand.in</span>
            </a>
          </div>

        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            name="name"
            placeholder="Your name"
            value={form.name}
            onChange={handleChange}
            required
            aria-label="Your name"
          />
          <input
            name="email"
            type="email"
            placeholder="Your email"
            value={form.email}
            onChange={handleChange}
            required
            aria-label="Your email"
          />
          <input
            name="company"
            placeholder="Company"
            value={form.company}
            onChange={handleChange}
            aria-label="Company"
          />
          <textarea
            name="message"
            rows="4"
            placeholder="Tell us about your project"
            value={form.message}
            onChange={handleChange}
            aria-label="Project details"
          />
          <button className="btn" type="submit">Send Message</button>
        </form>

      </div>
    </section>
  );
};

export default Contact;
